import axios, { AxiosResponse } from "axios";

import { Commodity, SamskipAPIResponse } from "@assets/types";

const SamskipAPI = process.env.SamskipAPI;

class CommodityService {
  getAllCommodities = async () => {
    const res: AxiosResponse<SamskipAPIResponse<Commodity[]>> = await axios.get(
      `${SamskipAPI}/Commodities`
    );
    return res.data.ReturnItem.Data;
  };

  getMachineryCommodities = async () => {
    const res: AxiosResponse<SamskipAPIResponse<Commodity[]>> = await axios.get(
      `${SamskipAPI}/Commodities/machineries`
    );
    return res.data.ReturnItem.Data;
  };
}

export default new CommodityService();
